module.exports = __webpack_public_path__ + "portal/static/img/kbank.066a02b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-bank/kbank.png
// module id = GQ7x
// module chunks = 67